import { PropTypes } from 'prop-types'

const AuthContainer = ({ children }) => {
  return (
    <div className="vizops-container">
      <div className="flex flex-col h-screen">{children}</div>
    </div>
  )
}
AuthContainer.propTypes = {
  children: PropTypes.node,
}
export default AuthContainer
